export default __webpack_public_path__ + "static/media/Pilgrim's Gloves of Shimmering Light.df45719c.jpg";